import { insuranceCarrierFromDto } from "@/features/insuranceCarriers/mappers/insuranceCarriersMapper";
import { planListFromDto } from "./plansMapper";
import { calculationFromDto } from "./calculationsMapper";

export const agreementListFromDto = (dto) => ({
  id: dto.id,
  name: dto.name,
  insuranceCarrier: insuranceCarrierFromDto(dto.insurance_carrier),
  plans: dto.plans.map(planListFromDto),
  startDate: dto.start_date,
  endDate: dto.end_date,
  createdAt: dto.created_at,
  active: dto.active,
});

export const agreementFromDto = (dto) => ({
  ...agreementListFromDto(dto),
  calculations: (dto.calculations ?? []).map(calculationFromDto),
});

export const agreementCreateToDto = (data) => ({
  name: data.name,
  insurance_carrier: data.insuranceCarrier,
  start_date: data.startDate,
  end_date: data.endDate,
});

export const agreementUpdateToDto = (data) => ({
  ...agreementCreateToDto(data), // Reutiliza los campos de creación y deja preparado el objeto para añadir campos específicos al actualizar
});